var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProgress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "run_stopwatch",
    "data-name": "run stopwatch",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_3",
    "data-name": "\\uD0C0\\uC6D0 3",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(1 1)",
    fill: "#e052ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_290",
    "data-name": "\\uADF8\\uB8F9 290"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_198",
    "data-name": "\\uD328\\uC2A4 198",
    d: "M18.729,10.461a6.65,6.65,0,1,0,3.383,3.351.7.7,0,0,0-1.276.575,5.251,5.251,0,1,1-2.67-2.644.7.7,0,0,0,.563-1.282Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_199",
    "data-name": "\\uD328\\uC2A4 199",
    d: "M16.44,16.16a.55.55,0,1,1-.778,0A.55.55,0,0,1,16.44,16.16Zm.4-1.394a1.951,1.951,0,0,0-2.575,2.575l-.481.48a.7.7,0,1,0,.99.99l.481-.48a1.951,1.951,0,0,0,2.575-2.575l3.132-3.132a.7.7,0,0,0-.99-.99Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_200",
    "data-name": "\\uD328\\uC2A4 200",
    d: "M15.351,6.4v.726a9.412,9.412,0,0,0-5.982,2.74.7.7,0,0,0,.99.99,8.05,8.05,0,1,1,0,11.385.7.7,0,0,0-.99.99,9.45,9.45,0,1,0,7.382-16.1V6.4h1.4a.7.7,0,1,0,0-1.4h-4.2a.7.7,0,0,0,0,1.4Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_201",
    "data-name": "\\uD328\\uC2A4 201",
    d: "M21.264,7.625l1.709,1.5a.7.7,0,0,0,.925-1.05l-1.709-1.5a.7.7,0,1,0-.925,1.05Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_202",
    "data-name": "\\uD328\\uC2A4 202",
    d: "M5.2,14.1H8.7a.7.7,0,0,0,0-1.4H5.2a.7.7,0,0,0,0,1.4Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_203",
    "data-name": "\\uD328\\uC2A4 203",
    d: "M5.784,17.249H8.117a.7.7,0,0,0,0-1.4H5.784a.7.7,0,1,0,0,1.4Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_204",
    "data-name": "\\uD328\\uC2A4 204",
    d: "M6.367,20.4h1.75a.7.7,0,0,0,0-1.4H6.367a.7.7,0,1,0,0,1.4Z",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgress);
export default __webpack_public_path__ + "static/media/progress.4ac1a02177e9feace6e5715cb251183c.svg";
export { ForwardRef as ReactComponent };